exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flatpickr-calendar.inline {\n    margin: 0 auto;\n}\n\n.upcoming-reminders p {\n    font-size: 18px;\n    color: #737373;\n    font-weight: 500;\n}", ""]);

// exports
